import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "react-phone-input-2/lib/style.css";
// import "../styles/enquiry.css";
import debounce from "lodash.debounce";
import { City } from "country-state-city";
import { useNavigate } from "react-router";
import Select from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import api from "../utils/axiosUtils";
import { LandingEnquiryFormSchema } from "../validatorSchema/formSchema";

const LandingEnquiryForm = ({ productTitle, onClose }) => {
  const [filteredCities, setFilteredCities] = useState([]);
  const navigate = useNavigate();

  const fetchCities = debounce((input) => {
    if (!input) return;

    const allCities = City.getAllCities();
    const filtered = allCities
      .filter((city) => city.name.toLowerCase().startsWith(input.toLowerCase()))
      .slice(0, 10)
      .map((city) => ({
        label: `${city.name}, ${city.stateCode}, ${city.countryCode}`,
        value: city.name,
      }));

    setFilteredCities(filtered);
  }, 300);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    const message = `
  *Hi Team TimeWatch,
  I'm interested In - ${values.productName}
  Please assist me.*
  
  *Product:* ${values.productName}
  *Name:* ${values.name}
  *Phone:* ${values.phone}
  *Email:* ${values.email}
  *Location:* ${values.location?.label || ""}
  
  Please follow up!
    `.trim();

    const phoneNumber = "919210068047";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    // window.open(whatsappURL, "_blank");

    try {
      await api.post("/baggage-scanner-popup", values);

      setSubmitting(false);
      onClose();
      navigate("/thankyou");
    } catch (error) {
      console.error("Error:", error);
      setSubmitting(false);
    }
  };
  return (
    <div className="modal d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div
            className="modal-header d-flex justify-content-between align-items-center"
            style={{ borderBottom: "none" }}
          >
            <h5 className="modal-title">Enquire Now</h5>
            <button
              type="button"
              className="close fw-bold fs-2"
              onClick={onClose}
              aria-label="Close"
              style={{
                border: "none",
                backgroundColor: "transparent",
                color: "#f14144",
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <Formik
              initialValues={{
                productName: productTitle,
                name: "",
                phone: "",
                email: "",
                location: null,
              }}
              validationSchema={LandingEnquiryFormSchema}
              onSubmit={handleSubmit}
            >
              {({ values, isSubmitting, setFieldValue }) => (
                <Form className="container-fluid">
                  <div className="form-group mb-3">
                    <label>Product Name</label>
                    <Field
                      name="productName"
                      className="form-control"
                      readOnly
                      style={{
                        cursor: "not-allowed",
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #ced4da",
                        borderRadius: "0.25rem",
                      }}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label>Name <span style={{ color: "#f14144" }}>*</span></label>
                    <Field name="name" className="form-control" />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label>Phone Number <span style={{ color: "#f14144" }}>*</span></label>
                    <Field name="phone" className="form-control" />
                    <ErrorMessage
                      name="phone"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label>Email ID</label>
                    <Field name="email" className="form-control" />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label
                      htmlFor="location"
                      className="mb-1"
                      style={{ fontSize: "18px" }}
                    >
                      Location
                    </label>
                    <Field name="location" className="form-control" placeholder="Where are you located?"/>
                    {/* <Select
                      id="location"
                      name="location"
                      options={filteredCities}
                      value={values.location}
                      onChange={(option) => setFieldValue("location", option)}
                      onInputChange={(value) => fetchCities(value)}
                      placeholder="Search your city..."
                      isSearchable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          border: "1px solid #dee2e6",
                          borderRadius: "0.375rem",
                          padding: "0",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#888",
                        }),
                      }}
                    /> */}
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-danger btn-block mt-3 mx-auto d-block px-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingEnquiryForm;
